module.exports = __webpack_public_path__ + "static/media/b-sci-major-9_LR.99ab69ed.jpg";